import { createContext, useContext } from 'react'

/**
 * Показывать элементы составного блока строго на языке правки, без подстановки
 * второго языка. Его ставит миниатюра ленты экранов: холст в правке подстановки
 * не делает (там правится именно этот слот), и миниатюра с картинкой второго
 * языка показывала бы то, чего на холсте нет — удалённая картинка «оставалась».
 */
export const StrictLangContext = createContext(false)

export const useStrictLang = () => useContext(StrictLangContext)
